import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/messages'
const getMessageUrl = 'v1/get-messages'
const plural = 'messages'
const single = 'message'

const messages = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})

messages.getMessages = (payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${getMessageUrl}`, payload, { timeout: 60000, ...options })
		.then(handleResponse)
		.catch(handleError);
}

messages.checkFileSize = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${getMessageUrl}/fileEstimate`, payload)
		.then(handleResponse)
		.catch(handleError);
}

messages.downloadFile = (payload,type, params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${getMessageUrl}/${type}`, payload, params)
		.then(handleResponse)
		.catch(handleError);
}

messages.patchMessageStoredFor = (id, payload) => {
	return axios
		.patch(`${apiProvider.BASE_URL}/${url}/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

messages.putMessageStoredFor = (id, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/store/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

messages.checkDownloadAllFileSize = (getPackageType, payload, params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${getMessageUrl}/${getPackageType}/file-estimate`, payload, params)
		.then(handleResponse)
		.catch(handleError);
}

messages.downloadAllFiles = (getPackageType, payloadType, payload, params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${getMessageUrl}/${getPackageType}/file-download/${payloadType}`, payload, params)
		.then(handleResponse)
		.catch(handleError);
}

messages.updateTransactionMessages = (id, payload) => {
	return axios
		.patch(`${apiProvider.BASE_URL}/${url}/submit/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

export default messages
